import React from 'react';
import PropTypes from 'prop-types';
import { DeviceMeta } from 'Roblox';

const { isInApp } = DeviceMeta();

function StipendSection({ translate, planInfo }) {
  function getRobuxPackage(plan) {
    const robuxText = plan.isRecurring
      ? translate('Label.AmountPerMonth', {
          amount: plan.robuxAmount,
          subTextStart: '',
          subTextEnd: ''
        })
      : plan.robuxAmount;
    const robuxHtmlElement = plan.isRecurring
      ? translate('Label.AmountPerMonth', {
          amount: plan.robuxAmount,
          subTextStart: '<span class="font-annotation">',
          subTextEnd: '</span>'
        })
      : plan.robuxAmount;

    const robuxClass = () => {
      return isInApp ? 'icon-robux-medium' : 'icon-robux-medium-desktop';
    };

    return (
      <div className='div-table-cell robux-package-item '>
        <div className='medium-header'>
          {translate('Label.PremiumPlanName', { type: plan.robuxAmount })}
        </div>
        <div className={robuxClass()} />
        <div className='robux-package-name'>
          <div
            className='extra-bold-header'
            data-text={robuxText}
            dangerouslySetInnerHTML={{
              __html: robuxHtmlElement
            }}
          />
        </div>
        <div className='font-header-2 text-disabled'>
          {plan.price.currency.currencySymbol + plan.price.amount}
        </div>
      </div>
    );
  }
  return (
    <div className='stipend-section'>
      <div className='robux-bg' />
      <div className='stipend-sec-header left-header'>
        <div className='font-title'>{translate('Heading.RobuxEveryMonth')}</div>
        <div className='font-header-2 text-subheader'>
          {translate('Description.ReceiveRobuxMonthly')}
        </div>
      </div>
      <div className='desktop-view'>
        <div className='div-table robux-package-container'>
          <div className='div-table-row'>
            {planInfo &&
              planInfo.map(plan => {
                return getRobuxPackage(plan);
              })}
          </div>
        </div>
      </div>
      <div className='mobile-view robux-package-container'>
        <div className='div-table'>
          {planInfo && planInfo.length > 1 && (
            <div className='div-table-row '>
              {planInfo[0] && getRobuxPackage(planInfo[0])}
              <div className='div-table-row '>{planInfo[1] && getRobuxPackage(planInfo[1])}</div>
              <div className='div-table-row'>{planInfo[2] && getRobuxPackage(planInfo[2])}</div>
            </div>
          )}
          {planInfo && planInfo.length === 1 && (
            <div className='div-table-row single-package'>{getRobuxPackage(planInfo[0])}</div>
          )}
        </div>
      </div>
    </div>
  );
}

StipendSection.propTypes = {
  translate: PropTypes.func.isRequired,
  planInfo: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.number.isRequired,
      robuxAmount: PropTypes.string.isRequired,
      isRecurring: PropTypes.bool.isRequired,
      price: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.shape({
          currencySymbol: PropTypes.string.isRequired
        }).isRequired
      }).isRequired
    })
  ).isRequired
};

export default StipendSection;
